import { createTheme } from "@mui/material/styles";

const gradientBg =
  "linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.2)), linear-gradient(135deg, rgba(96, 75, 128, 1) 0%, rgba(100, 92, 168, 1) 25%, rgba(111, 109, 167, 1) 50%, rgba(62, 53, 105, 1) 100%)";

const theme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#4a9eff",
      dark: "#1a237e",
      light: "#82b1ff",
    },
    secondary: {
      main: "#ff6b9d",
      dark: "#c2185b",
      light: "#ff94c2",
    },
    success: {
      main: "#4caf50",
    },
    warning: {
      main: "#51c4a0",
    },
    error: {
      main: "rgba(230, 90, 125, 1)",
    },
    background: {
      default: "transparent !important;",
      paper: "rgba(255, 255, 255, 0.06)",
      gradient:
        "linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.2)), linear-gradient(135deg, rgba(96, 75, 128, 1) 0%, rgba(100, 92, 168, 1) 25%, rgba(111, 109, 167, 1) 50%, rgba(62, 53, 105, 1) 100%)",
      cardGlass: "rgba(255, 255, 255, 0.08)",
    },
    text: {
      primary: "#f8fafc",
      secondary: "#cbd5e1",
      tertiary: "#94a3b8",
    },
    divider: "rgba(255, 255, 255, 0.12)",
  },
  custom: {
    gradientBg,
  },
  typography: {
    fontFamily: "Roboto Condensed, sans-serif",
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        "body, #root": {
          background: gradientBg,
          backgroundAttachment: "fixed",
          minHeight: "100vh",
        },
        // Custom scrollbars for the entire app
        "*::-webkit-scrollbar": {
          width: "8px",
          height: "8px",
        },
        "*::-webkit-scrollbar-track": {
          background: "rgba(255, 255, 255, 0.05)",
          borderRadius: "4px",
        },
        "*::-webkit-scrollbar-thumb": {
          background: "rgba(255, 255, 255, 0.2)",
          borderRadius: "4px",
          backdropFilter: "blur(8px)",
          border: "1px solid rgba(255, 255, 255, 0.1)",
        },
        "*::-webkit-scrollbar-thumb:hover": {
          background: "rgba(255, 255, 255, 0.3)",
        },
        // Firefox scrollbar
        "*": {
          scrollbarWidth: "thin",
          scrollbarColor: "rgba(255, 255, 255, 0.2) rgba(255, 255, 255, 0.05)",
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: ({ theme }) => ({
          backgroundColor: "rgba(255, 255, 255, 0.04)",
          backdropFilter: "blur(16px)",
          WebkitBackdropFilter: "blur(16px)",
          borderRadius: "16px",
          border: `1px solid rgba(255, 255, 255, 0.08)`,
          boxShadow: "none",
        }),
      },
    },
    MuiButton: {
      styleOverrides: {
        root: ({ theme }) => ({
          borderRadius: "12px",
          fontWeight: 600,
          textTransform: "none",
          fontSize: "0.9rem",
          padding: "8px 16px",
          border: "1px solid rgba(255, 255, 255, 0.1)",
          boxShadow: "none",
        }),
        contained: ({ theme }) => ({
          backgroundColor: theme.palette.primary.main,
          color: "#ffffff",
          "&:hover": {
            backgroundColor: theme.palette.primary.dark,
          },
        }),
        outlined: ({ theme }) => ({
          backgroundColor: "rgba(255, 255, 255, 0.02)",
          color: theme.palette.text.primary,
          borderColor: "rgba(255, 255, 255, 0.1)",
          "&:hover": {
            backgroundColor: "rgba(255, 255, 255, 0.05)",
            borderColor: "rgba(255, 255, 255, 0.2)",
          },
        }),
      },
    },
    MuiCard: {
      styleOverrides: {
        root: ({ theme }) => ({
          backgroundColor: "rgba(255, 255, 255, 0.04)",
          backdropFilter: "blur(16px)",
          WebkitBackdropFilter: "blur(16px)",
          borderRadius: "16px",
          border: "1px solid rgba(255, 255, 255, 0.08)",
          boxShadow: "none",
        }),
      },
    },
    MuiTypography: {
      styleOverrides: {
        h1: ({ theme }) => ({
          fontWeight: 700,
          background: `linear-gradient(135deg, ${theme.palette.text.primary} 0%, ${theme.palette.primary.light} 100%)`,
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          backgroundClip: "text",
        }),
        h2: ({ theme }) => ({
          fontWeight: 600,
          color: theme.palette.text.primary,
        }),
        h3: ({ theme }) => ({
          fontWeight: 600,
          color: theme.palette.text.primary,
        }),
      },
    },
  },
});

export default theme;
